




import { defineComponent } from '@nuxtjs/composition-api';
import useAppRoute from '~/compositions/useAppRoute';

/**
 * コンポーネントの始まり
 */
export default defineComponent({
  /**
   * このコンポーネントの初期化処理
   * (第一引数は props, 第二引数は SetupContext)
   */
  setup(_props, context) {
    const { URLs, redirect } = useAppRoute();

    // 学校からのメッセージ等に含まれる「企業ページ」のURLのバイパス対応
    redirect(
      context.root.localePath(
        URLs.show_corporation_summary_with_id(
          Number(context.root.$route.params.id)
        )
      )
    );
  },
});
